import { getCachedOrFetch, invalidateCachedValue } from './requestCache';
import { getEnv } from '../utils/env';

export type BackendVersionResponse = Record<string, unknown>;

const VERSION_TTL_MS = 30_000;

export const getBackendVersionValue = (response: BackendVersionResponse | null): string => {
  const version = response?.version;
  return typeof version === 'string' ? version : '';
};

export const getBackendTimestampValue = (response: BackendVersionResponse | null): string | null => {
  const timestamp = response?.timestamp;
  if (typeof timestamp === 'string' && timestamp.length > 0) return timestamp;
  return null;
};

export const getBackendAppEnvValue = (response: BackendVersionResponse | null): string => {
  const appEnv = response?.app_env;
  return typeof appEnv === 'string' ? appEnv : '';
};

export const isBackendDevelopmentEnv = (response: BackendVersionResponse | null): boolean =>
  getBackendAppEnvValue(response).toLowerCase() === 'development';

export const isBackendMigrationMode = (response: BackendVersionResponse | null): boolean =>
  response?.migration_mode === true;

export const getBackendVersionApi = async (forceRefresh = false): Promise<BackendVersionResponse | null> => {
  const apiUrl = getEnv('VITE_AI_API_URL', '').replace(/\/$/, '');
  if (!apiUrl) return null;

  if (forceRefresh) invalidateCachedValue('infra:version');

  return await getCachedOrFetch('infra:version', VERSION_TTL_MS, async () => {
    const response = await fetch(`${apiUrl}/version`, {
      headers: {
        'x-api-key': getEnv('VITE_AI_API_KEY', ''),
      },
    });

    if (!response.ok) {
      throw new Error(`Version API request failed (${response.status})`);
    }

    return await response.json() as BackendVersionResponse;
  });
};
